import { render } from "./AddHRISAcc.vue?vue&type=template&id=4128858a&scoped=true"
import script from "./AddHRISAcc.vue?vue&type=script&lang=js"
export * from "./AddHRISAcc.vue?vue&type=script&lang=js"

import "./AddHRISAcc.vue?vue&type=style&index=0&id=4128858a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4128858a"]])

export default __exports__